import { useCallback, useEffect, useState } from "react";
import { axiosInstance } from "../api/axiosDefaults";

export default function useActivePlan(options = {}) {
  const { skipInitialFetch = false } = options;
  const [currentlyActivePlans, setCurrentActivePlans] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchMyActivePlan = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/my-plan/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        withCredentials: true,
      });

      if (response?.data?.status === 200) {
        setLoading(false);
        setCurrentActivePlans(response?.data?.data);
      } else {
        setLoading(false);
        setCurrentActivePlans([]);
      }
    } catch (err) {
      setLoading(false);
      setCurrentActivePlans([]);
      console.log(err);
    }
  }, []);

  useEffect(() => {
    if (!skipInitialFetch) {
      fetchMyActivePlan();
    }
  }, [fetchMyActivePlan, skipInitialFetch]);
  return {
    loading,
    currentlyActivePlans,
    fetchMyActivePlan,
  };
}
